import { render, staticRenderFns } from "./ActivixRadio.vue?vue&type=template&id=1dc6c096&"
import script from "./ActivixRadio.vue?vue&type=script&lang=js&"
export * from "./ActivixRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports